"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chat_1 = require("@almservices-cl/chat");
class MessageSentListener {
    constructor(customerNotificationClient, logger) {
        this.onEvent = async (event) => {
            if (event instanceof chat_1.MessageSent) {
                await this.customerNotificationClient
                    .clearCustomerNotifications(event.customerId)
                    .catch(this.logger.error);
            }
        };
        this.customerNotificationClient = customerNotificationClient;
        this.logger = logger;
    }
}
exports.default = MessageSentListener;
//# sourceMappingURL=MessageSentListener.js.map